import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { useNavigate } from 'react-router-dom';
import globalStore from '@/store/global';
import navbarStore from '@/store/navbar';
import { SVGPureIcon } from '@/ui';
import agentSquareStore from './store';
import AgentItemCard from './agent-item';
import appLogger from '@public/log/monitor';
import ScrollView from '@/ui/scroll-view';

import './style.scss';

const SquareAgent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    agentSquareStore.getData();

    appLogger.log({
      key: 'aibot_agent',
      action: 'show',
      page: 'case_place',
    });
  }, []);

  const agentList =
    toJS(agentSquareStore.data)[agentSquareStore.activeTab] || [];

  if (!agentList?.list?.length) {
    return (
      <div className="square-agent w-full h-full">
        <div className="w-full h-full flex justify-center items-center">
          <div className="text-16px text-black leading-24px">暂无数据</div>
        </div>
      </div>
    );
  }

  return (
    <div className="px-4px size-full">
      <ScrollView className="square-agent w-full h-full relative">
        {/* <div
          className={[
            'absolute -top-3px left-24px flex items-center cursor-pointer',
          ]}
          onClick={() => {
            navigate('/tools/aiagent');
          }}
        >
          <SVGPureIcon name="header_back_arrow" className="size-24px" />
        </div> */}
        {/* tab */}
        <ul className="w-768px mx-auto flex flex-wrap gap-x-12px gap-y-8px my-24px">
          {agentSquareStore.data?.map((item, index) => {
            const isCur = agentSquareStore.activeTab === index;
            return (
              <li
                key={item.category}
                className={[
                  'inline-flex items-center h-30px px-14px flex gap-4px',
                  'bg-button-bg-normal rounded-8px cursor-pointer',
                  '!hover:bg-[rgba(0,0,0,0.06)] hover:border-none hover:px-15px',
                  'border-1px border-solid border-black border-opacity-10',
                  { 'border-white': globalStore.isDark },
                  { '!bg-[rgba(0,0,0,0.06)] border-none px-15px': isCur },
                  { '!bg-transparent': !isCur && globalStore.isDark },
                ]}
                onClick={() => agentSquareStore.setActiveTab(index)}
              >
                {item.title}
              </li>
            );
          })}
        </ul>

        {/* 列表 */}
        <div className="agent-list w-768px mx-auto grid grid-cols-2 gap-18px">
          {agentList?.list?.map((item, index) => {
            return (
              <AgentItemCard
                data={item}
                key={item.share_id + index}
                lineClamp={2}
                secne="agent_playground"
              />
            );
          })}
        </div>
      </ScrollView>
    </div>
  );
};

export default observer(SquareAgent);
